import COLORS from '../../utils/constants/colors'
import { CARD_STYLES } from '../../utils/constants/CSS/cardStyles'

const invitationsListStyles = {
  card: CARD_STYLES.card,
  cardTitle: CARD_STYLES.cardTitle,
  cardSubtitle: {
    ...CARD_STYLES.cardSubtitle,
  },
  empty: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 16,
    padding: '24px 0',
  },
  emptyText: {
    color: COLORS.grey,
  },
  mobileInvitation: {
    padding: '12px 0',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    '&:last-child': { borderBottom: 'none' },
  },
  mobileOrg: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  mobileOrgLogo: {
    width: 32,
    height: 32,
  },
  mobileOrgName: {
    fontWeight: 600,
    overflowWrap: 'anywhere',
  },
  mobileDetails: {
    fontSize: 14,
    color: COLORS.grey,
    marginTop: 4,
  },
  mobileActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 8,
    marginTop: 8,
  },
  cancelButton: {
    '&&': {
      color: COLORS.red,
    },
  },
  deleteButton: {
    '&&': {
      backgroundColor: COLORS.red,
      color: COLORS.white,
      '&:hover': {
        backgroundColor: COLORS.red,
      },
    },
  },
}

export default invitationsListStyles
